import Trainers from "./Trainers";
import TrainersForm from "./TrainersForm";

const TrainersConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/trainersList',
            element: <Trainers />,
        },
        {
            path: '/addTrainers',
            element: <TrainersForm />,
        },
    ],
}

export default TrainersConfig;